import { NgModule } from '@angular/core';
import { CommonModule } from "@angular/common";
import { RouterModule } from "@angular/router";
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { OverlayModule } from '@angular/cdk/overlay';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { PerfectScrollbarModule } from "ngx-perfect-scrollbar";
import { ClickOutsideModule } from 'ng-click-outside';
import { AutocompleteModule } from './components/autocomplete/autocomplete.module';
import { PipeModule } from '@shared/pipes/pipe.module';
import { NgSelectModule } from '@ng-select/ng-select';
import { NouisliderModule } from 'ng2-nouislider';
import { NgxBootstrapConfirmModule } from 'ngx-bootstrap-confirm';
import { NgxMasonryModule } from 'ngx-masonry';
import { ChartsModule } from 'ng2-charts';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
//COMPONENTS
import { NavbarComponent } from "./components/navbar/navbar.component";
import { VerticalMenuComponent } from "./components/vertical-menu/vertical-menu.component";
import { CustomizerComponent } from './components/customizer/customizer.component';
import { NotificationSidebarComponent } from './components/notification-sidebar/notification-sidebar.component';
import { SpinnerComponent } from './components/spinner/spinner.component';
import { FiltersRetailComponent } from './components/filters-retail/filters-retail.component';
//DIRECTIVES
import { ToggleFullscreenDirective } from "./directives/toggle-fullscreen.directive";
import { SidebarLinkDirective } from './directives/sidebar-link.directive';
import { SidebarDropdownDirective } from './directives/sidebar-dropdown.directive';
import { SidebarAnchorToggleDirective } from './directives/sidebar-anchor-toggle.directive';
import { SidebarDirective } from './directives/sidebar.directive';
import { TopMenuDirective } from './directives/topmenu.directive';
import { TopMenuLinkDirective } from './directives/topmenu-link.directive';
import { TopMenuDropdownDirective } from './directives/topmenu-dropdown.directive';
import { TopMenuAnchorToggleDirective } from './directives/topmenu-anchor-toggle.directive';
import {UiImageLoaderDirective}from './directives/img-loading.directive';
import { XChartComponent } from './components/x-chart/x-chart.component';
import { EChartComponent } from './components/echart/echart.component';
import * as echarts from 'echarts';
import { NgxEchartsModule } from 'ngx-echarts';
import { ImageHeatmapComponent } from './components/image-heatmap/image-heatmap.component';

@NgModule({
    exports: [
        ChartsModule,
        CommonModule,
        NavbarComponent,
        SpinnerComponent,
        VerticalMenuComponent,
        CustomizerComponent,
        FiltersRetailComponent,
        NotificationSidebarComponent,
        ToggleFullscreenDirective,
        SidebarDirective,
        TopMenuDirective,
        UiImageLoaderDirective,
        NgbModule,
        NouisliderModule,
        NgSelectModule,
        NgxBootstrapConfirmModule,
        XChartComponent,
        EChartComponent,
        ImageHeatmapComponent
    ],
    imports: [
        RouterModule,
        CommonModule,
        NgbModule,
        TranslateModule,
        FormsModule,
        OverlayModule,
        ReactiveFormsModule ,
        PerfectScrollbarModule,
        ClickOutsideModule,
        AutocompleteModule,
        PipeModule,
        NouisliderModule,
        NgSelectModule,
        NgxMasonryModule,
        ChartsModule,
        NgxEchartsModule.forRoot({ echarts }),
        TranslateModule.forChild(),
    ],
    declarations: [
        NavbarComponent,
        VerticalMenuComponent,
        CustomizerComponent,
        FiltersRetailComponent,
        NotificationSidebarComponent,
        ToggleFullscreenDirective,
        SidebarLinkDirective,
        SidebarDropdownDirective,
        SidebarAnchorToggleDirective,
        SidebarDirective,
        TopMenuLinkDirective,
        TopMenuDropdownDirective,
        TopMenuAnchorToggleDirective,
        TopMenuDirective,
        UiImageLoaderDirective,
        SpinnerComponent,
        XChartComponent,
        EChartComponent,
        ImageHeatmapComponent
    ]
})
export class SharedModule { }
